// extracted by mini-css-extract-plugin
export default {"root":"ScrollToTopButton_root__gVVDe","rootVisible":"ScrollToTopButton_rootVisible__tx6pF","rootTypePlayerOpen":"ScrollToTopButton_rootTypePlayerOpen__FayAZ"};